import type { Bonus, InventoryItem } from '../types/domain'
import { isBonus } from '../types/domain'
import { isItemApplicableToGame } from './isItemApplicableToGame'

interface SelectFreeBetsOptions {
  status: Bonus['status']
  /** When provided, keeps only bets applicable to this game ([] applicableGames = all games). */
  gameId?: string
}

/**
 * Pure selector for free bets (bonus items) by status and game applicability.
 * Shared by auto-claim, the grant banner and the sidebar so they always agree
 * on what counts as "a free bet you can use here".
 */
export function selectFreeBets(
  items: InventoryItem[],
  { status, gameId }: SelectFreeBetsOptions
): Bonus[] {
  return items.filter(
    (item): item is Bonus =>
      isBonus(item) && item.status === status && (!gameId || isItemApplicableToGame(item, gameId))
  )
}
